import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import { connect } from 'react-redux';

const styles = () => ({
  container: {
    margin: '100px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
  },

  title: {
    fontSize: '18px',
    lineHeight: '22px',
  },

  subheading: {
    marginTop: '14px',
    lineHeight: '24px'
  },

  linkBtn: {
    color: '#1A65FF',
    border: 'none',
    padding: '5px',
    marginTop: '10px',
    minHeight: 'unset',
    minWidth: 'unset',
    fontSize: '13px',
    textDecoration: 'underline',
  },
});

const InvalidAuthoritySection = props => {
  const { classes, isExeTimeline } = props;
  return (
    <div className={classes.container}>
      <Typography variant="display1" className={classes.title}>{isExeTimeline ? "キーマンデータベース" : "自社リスト"}の閲覧権限がありません。</Typography>
      <Typography variant="body2" className={classes.subheading}>
        管理者にお問い合わせください。
      </Typography>
    </div>
  );
}

InvalidAuthoritySection.propTypes = {
  classes: PropTypes.object.isRequired,
  isExeTimeline: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  const isExeTimeline = state.router.location.pathname.includes("executive-list");
  return {
    isExeTimeline: isExeTimeline,
  };
};

export default withStyles(styles)(connect(
  mapStateToProps
)(InvalidAuthoritySection));



// WEBPACK FOOTER //
// ./src/components/Timeline/sections/InvalidAuthoritySection.jsx